import { Box, Text } from '@wix/design-system';
import React from 'react';
import { MoneyBackIcon } from '@wix/package-picker-shared-eclipse';
import { EclipsePackagePickerModule } from '../../modules/eclipse-package-picker.module';
import s from './HeaderBanner.scss';

export const SlidingMoneyBackGuarantee = () => {
  const { t } = EclipsePackagePickerModule.internals.useTranslations();
  const moneyBackText = t('premium-purchase-plan.header.strip.money_back');

  // Render money-back guarantee badge (icon + text) - duplicated for seamless loop animation
  const MoneyBackGuarantee = () => (
    <Box className={s.slidingItem}>
      <MoneyBackIcon width={24} height={24} />
      <Text size="medium" weight="normal">
        {moneyBackText}
      </Text>
    </Box>
  );

  return (
    <Box className={s.slidingContainer}>
      <Box className={s.slidingText}>
        <MoneyBackGuarantee />
        <MoneyBackGuarantee />
      </Box>
    </Box>
  );
};
